import React from "react";
import mypic from "../../assets/images/achie.webp";
import PinCard from "./PinCard";
import gate from "../../assets/achievements/gate.webp";
import hackathon from "../../assets/achievements/hackathon2.webp";
import spotAward from "../../assets/achievements/spotaward.webp";
import publication from "../../assets/achievements/publication.webp";
import walmartHackthon from "../../assets/achievements/walmartHackthon.webp";
import walmartExcellence from "../../assets/achievements/excellance award.webp";
import walmartFireFighter from "../../assets/achievements/walmartFireFighter.webp";
import walmartImpactDriver from "../../assets/achievements/walmartImpactDriver.webp";

function Achievements() {
  return (
    <div className="flex flex-col items-center justify-between w-full h-full gap-4 pb-4 md:flex-row">
      <div className="flex w-[70%]  ">
        <img className="w-full h-full" src={mypic} alt="mypic" />
      </div>
      <div className="relative grid w-full grid-cols-2 gap-4 overflow-y-scroll h-[400px]">
        <PinCard
          title="Walmart Hackthon"
          description="Won 2nd price in walmart hackthon"
          img={walmartHackthon}
        />
        <PinCard
          title="Excellence Award"
          description="Received Excellance Award for resolve critical issues."
          img={walmartExcellence}
        />
        <PinCard
          title="Gate Qualified"
          description="Qualified Gate exam and achieved a score of 387"
          img={gate}
        />
        <PinCard
          title="Fire Fighter Award"
          description="For Dedication and Hard Working"
          img={walmartFireFighter}
        />
        <PinCard
          title="Impact Award"
          description="For implimenting complex feature in most optimized manner"
          img={walmartImpactDriver}
        />
        <PinCard
          title="TCS Hackthon Winner"
          description=" Participated and won TCS hackathons 7 Times."
          img={hackathon}
        />
        <PinCard
          title="On The Spot Award"
          description="Received from TCS for best performance."
          img={spotAward}
        />
        <PinCard
          title="Journal Published"
          description="journal published in international level"
          img={publication}
        />

        <div class="blob"></div>
      </div>
    </div>
  );
}

export default Achievements;
